import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import queryString from 'query-string';

import {request} from '../../containers/actions';
import {refresh as paginatorRefresh, removeItem, clearSelection} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import filtersSelectorGenerator from './filters';


export default class Books extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: 'title', label: window.gettext('Title')},
        {field: item => item.grade ? item.grade.title : '-', label: window.gettext('Grade')},
    ]

    filtersSelector = filtersSelectorGenerator.bind(this)()

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'title', label: window.gettext('title')},
        {name: 'grade', label: window.gettext('Grade')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            label: window.gettext('Remove'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s books?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/book/?' + queryString.stringify({
                                        id: this.props.store.getIn(['paginator', 'selected']).keySeq().join(','),
                                    }),
                                    method: 'DELETE',
                                }));
                                this.context.store.dispatch([
                                    ...this.props.store.getIn(['paginator', 'selected']).map(
                                        (__, id) => removeItem(id, this.props.store.getIn(['paginator', 'elementId'])),
                                    ).toArray(),
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                        {
                            label: window.gettext('Mass Edit'),
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
            () => this.props.readonly,
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New Book'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
            ])
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='book'
            title={window.gettext('Books')}
            listFields={this.listFields}
            selectable
            filters={this.filtersSelector(this.props.store)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.buttonActionsSelector(this.props.store)}
        />;
    }
}
